import dayjs, {convertToDayjs, formatDateWithUTC} from '@/dayjs'
import {GuestTypeV3} from '@/features/authentication/types.ts'
import {FC} from 'react'
import {useTranslation} from 'react-i18next'
import ConfettiAnimation from '../../confetti-animation/ConfettiAnimation'
import {CountdownTimer} from './components/countdown-timer/CountdownTimer'
import {HeaderBannerContainer} from './style'
import {useRootStore} from '@/store'
import {selectGetUltimateStatusModal} from '@/store/selectors'
import {LocalStorageManager} from '@/utilities/localStorage'

type HeaderBannerProps = {
    user: GuestTypeV3
}

export const HeaderBanner: FC<HeaderBannerProps> = ({user}) => {
    const {t} = useTranslation()
    const {openModal: openGetUltimateStatusModal} = useRootStore(selectGetUltimateStatusModal)
    const ultimateOffer = user?.typeAttributes?.ultimateOffer
    const cashBackOffer = user?.typeAttributes?.cashbackOffer

    // check if the leader canceled the ultimate offer in the modal
    const isRefusedUltimateStatus = LocalStorageManager.refusedUltimateStatus.get()
    const isUltimateStatusOfferAvailable = !!ultimateOffer?.isUltimateStatusOfferAvailable && !isRefusedUltimateStatus
    const isCashbackOfferAvailable = !!cashBackOffer?.isAvailableCashbackOffer

    const isBothOffersAvailable = isUltimateStatusOfferAvailable && isCashbackOfferAvailable

    const isShowBanner: boolean = isUltimateStatusOfferAvailable || isCashbackOfferAvailable || isBothOffersAvailable

    const offerEndDateLocal =
        (isUltimateStatusOfferAvailable &&
            ultimateOffer?.endDate &&
            formatDateWithUTC(ultimateOffer.endDate, 'YYYY-MM-DD HH:mm:ss')) ||
        (isCashbackOfferAvailable &&
            cashBackOffer?.endDate &&
            formatDateWithUTC(cashBackOffer.endDate, 'YYYY-MM-DD HH:mm:ss'))

    const isExpiredTime = (offerEndDateLocal && convertToDayjs(offerEndDateLocal).isBefore(dayjs())) || false

    if (!offerEndDateLocal || !isShowBanner || isExpiredTime) return <></>

    return (
        <HeaderBannerContainer
            id="headerTopBanner"
            onClick={() => isUltimateStatusOfferAvailable && openGetUltimateStatusModal({})}
            isUltimateStatusOfferAvailable={isUltimateStatusOfferAvailable}
        >
            <ConfettiAnimation />
            <CountdownTimer targetDate={offerEndDateLocal} showDays={false} />
            <span>
                {isBothOffersAvailable && t('promotion_banners:ultimate_status_top_banner')}
                {isCashbackOfferAvailable &&
                    !isUltimateStatusOfferAvailable &&
                    t('promotion_banners:cashback_top_banner')}
                {!isCashbackOfferAvailable &&
                    isUltimateStatusOfferAvailable &&
                    t('promotion_banners:ultimate_status_top_banner')}
            </span>
        </HeaderBannerContainer>
    )
}
